function SparkleLoader() {
  this.el = jQuery('<div class="sparkle-loader"></div>');
  this.spinner = jQuery('<div class="spinner"></div>');
  this.spinner.appendTo(this.el);
}

window.SparkleLoader = SparkleLoader;
